import AnimatedLogoutIcon from './animated-logout-icon';

export default AnimatedLogoutIcon;
